import { render } from "./AiCopilotSidebar.vue?vue&type=template&id=05a6cb41&scoped=true"
import script from "./AiCopilotSidebar.vue?vue&type=script&lang=js"
export * from "./AiCopilotSidebar.vue?vue&type=script&lang=js"

import "./AiCopilotSidebar.vue?vue&type=style&index=0&id=05a6cb41&lang=css"
import "./AiCopilotSidebar.vue?vue&type=style&index=1&id=05a6cb41&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a6cb41"]])

export default __exports__